import { Button, ButtonProps } from "@mui/material";

const DialogActionPrimary: React.FC<ButtonProps> = ({ ...props }) => <Button {...props} variant="contained" />;
export default DialogActionPrimary;
